const deleteStrategies = {
  ADOPT: 'adopt',
  ORPHAN: 'orphan',
  DELETE: 'delete'
};

export default deleteStrategies;
